import React from "react";
import { Fragment } from "react";
import SportsListingViewModel from "./SportsListingViewModel";
import { PulseLoader } from "react-spinners";
import { Link } from "react-router-dom";
import NoDataFound from "../../../../Components/NoDataFound/NoDataFound";

const SportsListing = () => {
  const { SportsArray, AuthUser, IsLoading } = SportsListingViewModel();
  return (
    <Fragment>
      {/* Page Wrapper */}
      <div className="page-wrapper sports-listing-page">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Sports</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={`/user/${AuthUser?.UserType}/dashboard`}>
                      Dashboard
                    </Link>
                  </li>
                  <li className="breadcrumb-item active">Sports</li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table">
                <div className="card-body">
                  {/* Page Header */}
                  <div className="page-header">
                    <div className="row align-items-center">
                      <div className="col">
                        <h3 className="page-title">Sports</h3>
                      </div>
                    </div>
                  </div>
                  {/* /Page Header */}
                  {IsLoading ? (
                    <PulseLoader
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      color="#3D5EE1"
                      size={16}
                    />
                  ) : (
                    <div className="table-responsive">
                      <table className="table border-0 star-student table-hover table-center mb-0 datatable table-striped">
                        <thead className="student-thread">
                          <tr>
                            <th>ID</th>
                            <th>Name</th>
                            <th>Coach</th>
                            <th>Started Year</th>
                          </tr>
                        </thead>
                        <tbody>
                          {SportsArray &&
                            SportsArray.map((item, index) => {
                              return (
                                <tr key={index}>
                                  <td>{item?.SportID}</td>
                                  <td>{item?.SportName}</td>
                                  <td>{item?.CoachName}</td>
                                  <td>{item?.StartedYear}</td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                      {SportsArray?.length <= 0 && <NoDataFound />}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
    </Fragment>
  );
};

export default SportsListing;
